import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import flatten from 'lodash/flatten';
import {
  prepareBaseModuleItemFieldsToSubmit,
  convertBaseModuleItemFieldsToCreateForm,
} from '../../../../common';
import { baseModuleScreens } from '../../../../constants';
import { changeBaseModuleScreen } from '../../../../actions/baseModule';
import { saveBaseModuleItem, saveNsiProductType, saveNsiDetailFilters, togglePublishBaseModuleItem } from '../../../../actions/baseModuleItems';
import BaseModuleItemForm from './BaseModuleItemForm';
import { loadTags } from '../../../../actions/tags';

const propTypes = {
  currentModule: PropTypes.object.isRequired,
  changeBaseModuleScreen: PropTypes.func.isRequired,
  saveBaseModuleItem: PropTypes.func.isRequired,
  saveNsiProductType: PropTypes.func.isRequired,
  productTypes: PropTypes.array.isRequired,
  detailFilters: PropTypes.array.isRequired,
  saveNsiDetailFilters: PropTypes.func.isRequired,
  selectableItems: PropTypes.array.isRequired,
  loadTags: PropTypes.func.isRequired,
  allTags: PropTypes.array,
};

const defaultProps = {
  allTags: [],
};

class BaseModuleItemCreate extends Component {
  constructor(props) {
    super(props);

    this.initialValues = {
      title: null,
      categories: [],
      fields: convertBaseModuleItemFieldsToCreateForm(props.currentModule.fields),
      tags: [],
    };
  }

  componentDidMount() {
    this.props.loadTags();
  }

  handleSubmit = (formValues) => {
    const formBody = { ...formValues };
    const fields = prepareBaseModuleItemFieldsToSubmit(formBody.fields);
    const detailFiltersIds = formBody.detailFilters ? flatten(Object.values(formBody.detailFilters)) : [];
    formBody.fields = fields;
    let productCodes = [];
    if (formBody.productCodes) {
      productCodes = Object.keys(formBody.productCodes).map(key => ({
        detailFilterIds: key.split(','),
        code: formBody.productCodes[key],
      }));
    }

    return this.props.saveBaseModuleItem(formBody)
      .then((res) => {
        const { type } = formBody;

        if (type) this.props.saveNsiProductType(res.response.id, { type });

        if (detailFiltersIds.length) {
          const detailFilters = {
            baseModuleItemId: res.response.id,
            detailFiltersIds,
            productCodes,
          };
          this.props.saveNsiDetailFilters(detailFilters);
        }
        return this.props.changeBaseModuleScreen(baseModuleScreens.moduleItemsList);
      });
  };

  render() {
    const { currentModule, productTypes, detailFilters, selectableItems } = this.props;
    return (
      <div className="c-bb-basemodule c-bb-basemodule__item-create">
        <div className="c-bb-form">
          <BaseModuleItemForm
            productTypes={productTypes}
            detailFilters={detailFilters}
            initialValues={this.initialValues}
            currentModule={currentModule}
            onSubmit={this.handleSubmit}
            selectable={selectableItems}
            changeScreen={this.props.changeBaseModuleScreen}
            allTags={this.props.allTags}
          />
        </div>
      </div>
    );
  }
}

BaseModuleItemCreate.propTypes = propTypes;
BaseModuleItemCreate.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  const {
    baseModule: {
      isOpen,
      currentModule,
      currentModule: {
        categories,
      },
    },
    global: {
      tags,
    },
  } = state;

  let productTypes = [];
  let detailFilters = [];

  if (currentModule && currentModule.internal_name === 'product') {
    productTypes = state.baseModuleItems.customProductTypes;
    detailFilters = state.baseModuleItems.customDetailFilters;
  }

  return {
    isOpen,
    currentModule,
    productTypes,
    detailFilters,
    selectableItems: categories,
    allTags: tags,
  };
};

const mapDispatchToProps = {
  changeBaseModuleScreen,
  saveBaseModuleItem,
  saveNsiProductType,
  saveNsiDetailFilters,
  togglePublishBaseModuleItem,
  loadTags,
};

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(BaseModuleItemCreate));



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleItems/BaseModuleItemEdit/BaseModuleItemCreate.js